(function () {
  var SECTION_SELECTOR = '[data-ctr-announcement-bar]';
  var HEIGHT_VAR = '--ctr-announcement-height';
  var HEIGHT_FULL_VAR = '--ctr-announcement-height-full';
  var MOBILE_MQ = '(max-width: 749px)';
  var STICKY_MQ = '(max-width: 989px)';

  function getSwiper() {
    return window.Swiper || null;
  }

  function getSectionEl(root) {
    return root.closest('.shopify-section') || root;
  }

  function getStickyBehavior(root) {
    var isMobile = window.matchMedia(STICKY_MQ).matches;
    var behavior = isMobile
      ? root.dataset.stickyMobile
      : root.dataset.stickyDesktop;
    return behavior || 'none';
  }

  function isStickyEnabled(root) {
    return getStickyBehavior(root) !== 'none';
  }

  function isSectionVisible(el) {
    if (!el) return false;
    if (el.hidden || el.getAttribute('hidden') !== null) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    if (el.getBoundingClientRect().height < 1) return false;
    return true;
  }

  function ensureFullHeight(root) {
    var sectionEl = getSectionEl(root);
    if (!isSectionVisible(sectionEl) || !isSectionVisible(root)) {
      sectionEl._ctrAbFullHeight = 0;
      return 0;
    }
    if (sectionEl._ctrAbFullHeight) return sectionEl._ctrAbFullHeight;

    var height = Math.round(sectionEl.getBoundingClientRect().height);
    if (height < 1) {
      height =
        parseInt(
          getComputedStyle(document.documentElement).getPropertyValue(HEIGHT_FULL_VAR),
          10
        ) || 40;
    }

    sectionEl._ctrAbFullHeight = height;
    document.documentElement.style.setProperty(HEIGHT_FULL_VAR, height + 'px');
    return height;
  }

  function setAnnouncementHeight(root) {
    var sectionEl = getSectionEl(root);
    if (
      sectionEl.classList.contains('ctr-announcement-bar-section--hidden') ||
      !isSectionVisible(sectionEl) ||
      !isSectionVisible(root)
    ) {
      document.documentElement.style.setProperty(HEIGHT_VAR, '0px');
      root.style.setProperty(HEIGHT_VAR, '0px');
      return;
    }

    if (!isStickyEnabled(root) || !sectionEl.classList.contains('ctr-announcement-bar-section--sticky')) {
      document.documentElement.style.setProperty(HEIGHT_VAR, '0px');
      root.style.setProperty(HEIGHT_VAR, '0px');
      return;
    }

    var height = ensureFullHeight(root);
    document.documentElement.style.setProperty(HEIGHT_VAR, height + 'px');
    document.documentElement.style.setProperty(HEIGHT_FULL_VAR, height + 'px');
    root.style.setProperty(HEIGHT_VAR, height + 'px');
  }

  function refreshHeaderHeight() {
    var stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader && typeof stickyHeader.setHeaderHeight === 'function') {
      stickyHeader.setHeaderHeight();
    }
  }

  function updateStickyHeight(root) {
    setAnnouncementHeight(root);
    refreshHeaderHeight();
  }

  function destroySwiper(root) {
    if (root._ctrAbSwiper) {
      root._ctrAbSwiper.destroy(true, true);
      root._ctrAbSwiper = null;
    }
  }

  function initSwiper(root) {
    var SwiperLib = getSwiper();
    var el = root.querySelector('[data-ctr-ab-swiper]');
    if (!SwiperLib || !el) return;

    destroySwiper(root);

    if (!window.matchMedia(MOBILE_MQ).matches) return;

    var autoplay = el.getAttribute('data-ctr-ab-autoplay') === 'true';
    var speedSec = parseInt(el.getAttribute('data-ctr-ab-speed'), 10);
    if (isNaN(speedSec) || speedSec < 1) speedSec = 5;

    var options = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      allowTouchMove: true,
      watchOverflow: true,
      on: {
        slideChange: function () {
          updateStickyHeight(root);
        },
      },
    };

    if (autoplay) {
      options.autoplay = {
        delay: speedSec * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    root._ctrAbSwiper = new SwiperLib(el, options);
  }

  function clearAnnouncementSticky(root) {
    var sectionEl = getSectionEl(root);
    sectionEl.classList.remove(
      'ctr-announcement-bar-section--sticky',
      'ctr-announcement-bar-section--hidden'
    );
    document.documentElement.style.setProperty(HEIGHT_VAR, '0px');
    root.style.setProperty(HEIGHT_VAR, '0px');
    refreshHeaderHeight();
  }

  function showAnnouncement(root) {
    var sectionEl = getSectionEl(root);
    var fullHeight = ensureFullHeight(root);

    if (
      sectionEl.classList.contains('ctr-announcement-bar-section--sticky') &&
      !sectionEl.classList.contains('ctr-announcement-bar-section--hidden')
    ) {
      return;
    }

    document.documentElement.style.setProperty(HEIGHT_FULL_VAR, fullHeight + 'px');

    // Start off-screen, then slide in so the appear isn't abrupt.
    sectionEl.classList.add(
      'ctr-announcement-bar-section--sticky',
      'ctr-announcement-bar-section--hidden'
    );

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        sectionEl.classList.remove('ctr-announcement-bar-section--hidden');
        document.documentElement.style.setProperty(HEIGHT_VAR, fullHeight + 'px');
        root.style.setProperty(HEIGHT_VAR, fullHeight + 'px');
        refreshHeaderHeight();
      });
    });
  }

  function hideAnnouncement(root) {
    var sectionEl = getSectionEl(root);

    if (!sectionEl.classList.contains('ctr-announcement-bar-section--sticky')) {
      return;
    }

    if (sectionEl.classList.contains('ctr-announcement-bar-section--hidden')) {
      return;
    }

    ensureFullHeight(root);
    sectionEl.classList.add('ctr-announcement-bar-section--hidden');
    document.documentElement.style.setProperty(HEIGHT_VAR, '0px');
    root.style.setProperty(HEIGHT_VAR, '0px');
    refreshHeaderHeight();
  }

  function destroyScrollSticky(root) {
    if (root._ctrAbScrollHandler) {
      window.removeEventListener('scroll', root._ctrAbScrollHandler);
      root._ctrAbScrollHandler = null;
    }

    if (root._ctrAbScrollMqCleanup) {
      root._ctrAbScrollMqCleanup();
      root._ctrAbScrollMqCleanup = null;
    }

    getSectionEl(root).classList.remove('ctr-announcement-bar-section--hidden');
  }

  function syncStickyClass(root) {
    var sectionEl = getSectionEl(root);
    var behavior = getStickyBehavior(root);

    if (behavior === 'always') {
      sectionEl.classList.add('ctr-announcement-bar-section--sticky');
      sectionEl.classList.remove('ctr-announcement-bar-section--hidden');
      return;
    }

    if (behavior === 'none') {
      clearAnnouncementSticky(root);
      return;
    }

    // on-scroll-up: sticky only after a scroll-up reveal
    sectionEl.classList.remove(
      'ctr-announcement-bar-section--sticky',
      'ctr-announcement-bar-section--hidden'
    );
    document.documentElement.style.setProperty(HEIGHT_VAR, '0px');
  }

  function initScrollSticky(root) {
    var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var boundsBottom = 50;

    var measureBounds = function () {
      var sectionEl = getSectionEl(root);
      var rect = sectionEl.getBoundingClientRect();
      boundsBottom = Math.max(50, Math.ceil(rect.bottom + (window.pageYOffset || 0)));
      sectionEl._ctrAbFullHeight = null;
      ensureFullHeight(root);
    };

    measureBounds();

    var onScroll = function () {
      var behavior = getStickyBehavior(root);

      if (behavior === 'none') {
        clearAnnouncementSticky(root);
        return;
      }

      if (behavior === 'always') {
        syncStickyClass(root);
        updateStickyHeight(root);
        return;
      }

      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > currentScrollTop && scrollTop > boundsBottom) {
        hideAnnouncement(root);
      } else if (scrollTop < currentScrollTop && scrollTop > boundsBottom) {
        showAnnouncement(root);
      } else if (scrollTop <= 0) {
        clearAnnouncementSticky(root);
      }

      currentScrollTop = scrollTop;
    };

    var mq = window.matchMedia(STICKY_MQ);
    var onMqChange = function () {
      syncStickyClass(root);
      measureBounds();
      updateStickyHeight(root);
    };

    root._ctrAbScrollHandler = onScroll;
    window.addEventListener('scroll', onScroll, { passive: true });

    if (mq.addEventListener) {
      mq.addEventListener('change', onMqChange);
    } else if (mq.addListener) {
      mq.addListener(onMqChange);
    }

    root._ctrAbScrollMqCleanup = function () {
      if (mq.removeEventListener) {
        mq.removeEventListener('change', onMqChange);
      } else if (mq.removeListener) {
        mq.removeListener(onMqChange);
      }
    };
  }

  function initSticky(root) {
    var desktop = root.dataset.stickyDesktop || 'none';
    var mobile = root.dataset.stickyMobile || 'none';
    if (desktop === 'none' && mobile === 'none') return;

    syncStickyClass(root);

    var update = function () {
      getSectionEl(root)._ctrAbFullHeight = null;
      updateStickyHeight(root);
    };

    update();

    if (typeof ResizeObserver !== 'undefined') {
      var observer = new ResizeObserver(update);
      observer.observe(getSectionEl(root));
      root._ctrAnnouncementObserver = observer;
    }

    window.addEventListener('resize', update);
    root._ctrAnnouncementResize = update;

    if (
      desktop === 'on-scroll-up' ||
      mobile === 'on-scroll-up' ||
      desktop === 'always' ||
      mobile === 'always'
    ) {
      initScrollSticky(root);
    }
  }

  function destroySticky(root) {
    destroyScrollSticky(root);

    if (root._ctrAnnouncementObserver) {
      root._ctrAnnouncementObserver.disconnect();
      root._ctrAnnouncementObserver = null;
    }

    if (root._ctrAnnouncementResize) {
      window.removeEventListener('resize', root._ctrAnnouncementResize);
      root._ctrAnnouncementResize = null;
    }

    var sectionEl = getSectionEl(root);
    sectionEl.classList.remove(
      'ctr-announcement-bar-section--sticky',
      'ctr-announcement-bar-section--hidden'
    );
  }

  function initAnnouncementBar(root) {
    if (!root) return;

    destroySwiper(root);
    destroySticky(root);

    if (root._ctrAbMqCleanup) {
      root._ctrAbMqCleanup();
      root._ctrAbMqCleanup = null;
    }

    initSticky(root);
    initSwiper(root);

    var mq = window.matchMedia(MOBILE_MQ);
    var onChange = function () {
      initSwiper(root);
      updateStickyHeight(root);
    };

    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else if (mq.addListener) {
      mq.addListener(onChange);
    }

    root._ctrAbMqCleanup = function () {
      if (mq.removeEventListener) {
        mq.removeEventListener('change', onChange);
      } else if (mq.removeListener) {
        mq.removeListener(onChange);
      }
    };
  }

  function destroyAnnouncementBar(root) {
    if (!root) return;

    destroySwiper(root);
    destroySticky(root);

    if (root._ctrAbMqCleanup) {
      root._ctrAbMqCleanup();
      root._ctrAbMqCleanup = null;
    }
  }

  function whenSwiperReady(cb) {
    if (getSwiper()) {
      cb();
      return;
    }

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (getSwiper() || tries > 40) {
        clearInterval(timer);
        cb();
      }
    }, 50);
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(function (root) {
      whenSwiperReady(function () {
        initAnnouncementBar(root);
      });
    });
  }

  function reinit(event) {
    var section = event && event.target;
    if (!section) {
      initAll();
      return;
    }

    var root = section.querySelector
      ? section.querySelector(SECTION_SELECTOR)
      : null;
    if (!root && section.matches && section.matches(SECTION_SELECTOR)) {
      root = section;
    }
    if (!root) return;

    whenSwiperReady(function () {
      initAnnouncementBar(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', reinit);
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector(SECTION_SELECTOR)
      : null;
    destroyAnnouncementBar(root);
  });
  document.addEventListener('shopify:section:reorder', initAll);
  document.addEventListener('shopify:section:select', reinit);
  document.addEventListener('shopify:section:deselect', reinit);

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target && event.target.closest
      ? event.target.closest('[data-ctr-ab-slide]')
      : null;
    if (!slide) return;

    var root = slide.closest(SECTION_SELECTOR);
    if (!root || !root._ctrAbSwiper) return;

    var slides = root.querySelectorAll('[data-ctr-ab-slide]');
    var index = Array.prototype.indexOf.call(slides, slide);
    if (index < 0) return;

    if (root._ctrAbSwiper.params.loop) {
      root._ctrAbSwiper.slideToLoop(index);
    } else {
      root._ctrAbSwiper.slideTo(index);
    }
  });
})();
